// extracted by mini-css-extract-plugin
module.exports = {"root":"ppe-disposal-page_root__f38lD"};